<template>
  <div style="height: 2500px">
    <el-select
      v-model="daytype"
      @change="handleChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.text"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="caltype"
      @change="handleCalChange"
    >
      <!-- 核心：默认汇总选项，value 设为空字符串 -->
      <el-option
        label="汇总"
        value=""
      ></el-option>
      <el-option
        v-for="item in caloptions"
        :key="item.categoryLevel1Id"
        :label='`${item.categoryLevel1Name}`'
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      v-if="brandoptions.length > 0"
      v-model="brandtype"
      @change="handleBrandChange"
    >
      <!-- 核心：默认汇总选项，value 设为空字符串 -->
      <el-option
        label="汇总"
        value=""
      ></el-option>
      <el-option
        v-for="item in brandoptions"
        :key="item.categoryLevel3Id"
        :label='`${item.brandName}`+`${item.categoryLevel1Name}/${item.categoryLevel2Name}/${item.categoryLevel3Name}`'
        :value="item"
      >
      </el-option>
    </el-select>
    <el-button
      type="primary"
      @click="downloadGrassDailyData()"
    >下载任务日期明细数据</el-button>
    <el-button
      type="primary"
      @click="downloadGrassSummaryData()"
    >下载任务汇总数据</el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      style="width: 100%"
      border
    >
      <el-table-column
        prop="contentVisitUv"
        label="阅读UV"
      >
      </el-table-column>

      <el-table-column
        prop="contentThumbsCount"
        label="点赞UV"
      >
      </el-table-column>

      <el-table-column
        prop="contentCollectUv"
        label="收藏UV"
      >
      </el-table-column>

      <el-table-column
        prop="contentCommentsCount"
        label="评论UV"
      >
      </el-table-column>

      <el-table-column
        prop="contentSharesCount"
        label="分享UV"
      >
      </el-table-column>

      <el-table-column
        prop="interactionRate"
        label="内容互动率"
        :formatter="ChangeToPercentage"
      >
      </el-table-column>

      <el-table-column
        prop="industryInteractionRate"
        label="行业均值"
        :formatter="ChangeToPercentage"
      >
      </el-table-column>

      <el-table-column
        prop="searchExpoUv"
        label="搜索曝光UV"
      >
      </el-table-column>
      <el-table-column
        prop="searchCount"
        label="搜索浏览UV"
      >
      </el-table-column>

      <el-table-column
        prop="goodsViewUv"
        label="商详浏览UV"
      >
      </el-table-column>

      <el-table-column
        prop="browseSkuRate"
        label="商详到达率"
        :formatter="ChangeToPercentage"
      >
      </el-table-column>

      <el-table-column
        prop="goodCartUv"
        label="商品加购UV"
      >
      </el-table-column>

      <el-table-column
        prop="goodCollectUv"
        label="商品收藏UV"
      >
      </el-table-column>

      <el-table-column
        prop="addCartRate"
        label="加购率"
        :formatter="ChangeToPercentage"
      >
      </el-table-column>

      <el-table-column
        prop="orderUv"
        label="下单UV"
      >
      </el-table-column>

      <el-table-column
        prop="pushSkuOrderUv"
        label="主推商品下单uv"
      >
      </el-table-column>

      <el-table-column
        prop="orderGmv"
        label="下单GMV"
      >
      </el-table-column>

      <el-table-column
        prop="pushSkuOrderAmount"
        label="主推商品下单GMV"
      >
      </el-table-column>

      <el-table-column
        prop="orderCompleteUv"
        label="成交UV"
      >
      </el-table-column>

      <el-table-column
        prop="pushSkuDealUv"
        label="主推商品成交uv"
      >
      </el-table-column>

      <el-table-column
        prop="orderCompleteGmv"
        label="成交GMV"
      >
      </el-table-column>

      <el-table-column
        prop="pushSkuDealAmount"
        label="主推商品成交GMV"
      >
      </el-table-column>

      <el-table-column
        prop="ordConversionRate"
        label="下单率"
        :formatter="ChangeToPercentage"
      >
      </el-table-column>

      <el-table-column
        prop="newCustomerCount"
        label="新客UV"
      >
      </el-table-column>

      <el-table-column
        prop="newUserRate"
        label="新客率"
        :formatter="ChangeToPercentage"
      >
      </el-table-column>

    </el-table>

    <div
      id="myChart"
      :style="{width: '100%', height: '380px'}"
    ></div>
    <el-button
      type="primary"
      @click="downloadAllXhmOrder()"
    >下载任务订单汇总数据</el-button>

    <el-table
      :data="orderTableData"
      v-loading="loading"
      style="width: 100%"
      border
    >
      <el-table-column
        prop="mediaOrderId"
        label="媒体订单ID"
      >
      </el-table-column>

      <el-table-column
        prop="mediaOrderName"
        label="媒体订单名称	"
      >
      </el-table-column>

      <el-table-column
        prop="mediaOrderStatusName"
        label="媒体订单状态	"
      >
      </el-table-column>

      <el-table-column
        prop="orderPrice"
        label="媒体订单总金额	"
      >
      </el-table-column>

      <el-table-column
        prop="categoryName"
        label="推广类目	"
      >
      </el-table-column>

      <el-table-column
        prop="contentVisitUv"
        label="阅读UV	"
      >
      </el-table-column>

      <el-table-column
        prop="contentThumbsCount"
        label="点赞UV	"
      >
      </el-table-column>

      <el-table-column
        prop="contentCollectUv"
        label="收藏UV	"
      >
      </el-table-column>

      <el-table-column
        prop="contentCommentsCount"
        label="评论UV	"
      >
      </el-table-column>

      <el-table-column
        prop="contentSharesCount"
        label="分享UV	"
      >
      </el-table-column>

      <el-table-column
        prop="jdActiveUv"
        label="活跃UV	"
      >
      </el-table-column>

      <el-table-column label="下载数据">
        <template slot-scope="scope">
          <el-button
            plain
            class="handel"
            @click="downloadXhmOrder(scope.row)"
          >订单日期明细数据</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>

</template>
<script>
import {
  getXhmDetailV2,
  getXhmDailyV2,
  getXhmOrderV2,
  downloadXhmOrderV2,
  downloadAllXhmOrderV2,
  getXhmBrandV2,
  downloadGrassSummaryData,
  downloadGrassDailyData
} from "@/api/xhmdetail";
import * as echarts from "echarts";

export default {
  data() {
    return {
      taskId: "",
      backendData: [],
      options: [
        { value: "15", text: "15天" },
        { value: "30", text: "30天" }
      ],
      caloptions: [],
      brandoptions: [],
      // 定义选中的值
      daytype: "15", // 默认值
      brandtype: null,
      caltype: "汇总",
      cateId: null,
      taskName: "",
      brandId: null,
      hasBrand: false,
      dataScope: 1,
      tableData: [],
      orderTableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false
    };
  },
  mounted() {
    this.taskId = this.$route.query.taskId;
    this.taskName = this.$route.query.taskName;
    this.getXhmBrandV2();
    this.search();
  },
  methods: {
    ChangeToPercentage(row, column) {
      var data1 = (row[column.property] * 100).toFixed(2) + "%";
      return data1;
    },
    async downFileBlob(fileName, fileBlob) {
      const blob = new Blob([fileBlob], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8"
      });
      const elink = document.createElement("a");
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    async downloadXhmOrder(val) {
      await downloadXhmOrderV2({
        taskId: val.taskId,
        orderId: val.mediaOrderId,
        brandId: this.brandId,
        cateId: this.cateId,
        dataScope: this.dataScope
      }).then(res => {
        this.downFileBlob(`订单数据_${new Date().getTime()}.xlsx`, res.data);
      });
    },
    async downloadAllXhmOrder() {
      await downloadAllXhmOrderV2({ taskId: this.taskId }).then(res => {
        this.downFileBlob(
          `订单汇总数据_${new Date().getTime()}.xlsx`,
          res.data
        );
      });
    },

    async downloadGrassSummaryData() {
      await downloadGrassSummaryData({
        taskId: this.taskId,
        pageNo: this.currentPage,
        dataCycle: this.daytype,
        brandId: this.brandId,
        cateId: this.cateId,
        dataScope: this.dataScope
      }).then(res => {
        this.downFileBlob(
          `任务汇总数据_${new Date().getTime()}.xlsx`,
          res.data
        );
      });
    },
    async downloadGrassDailyData() {
      await downloadGrassDailyData({
        taskId: this.taskId,
        pageNo: this.currentPage,
        dataCycle: this.daytype,
        brandId: this.brandId,
        cateId: this.cateId,
        dataScope: this.dataScope
      }).then(res => {
        this.downFileBlob(
          `任务日期明细数据_${new Date().getTime()}.xlsx`,
          res.data
        );
      });
    },
    async getXhmOrder() {
      this.taskId = this.$route.query.taskId;
      await getXhmOrderV2({
        taskId: this.taskId,
        pageNo: this.currentPage,
        dataCycle: this.daytype,
        brandId: this.brandId,
        cateId: this.cateId,
        dataScope: this.dataScope
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          this.orderTableData = res.data.content.data;
          this.total = res.data.content.total;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    // 核心逻辑：根据 categoryLevel3Id 拆分数据到不同下拉框
    splitDataToDropdowns() {
      // 初始化下拉框选项
      this.caloptions = [];
      this.brandoptions = [];

      // 遍历后端数据，按条件分类
      this.backendData.forEach(item => {
        // 判空：兼容 null/undefined/空字符串
        const hasLevel3Id =
          item.categoryLevel3Id && item.categoryLevel3Id.trim() !== "";

        if (hasLevel3Id) {
          // categoryLevel3Id 不为空 → 下拉框2
          this.brandoptions.push(item);
        } else {
          // categoryLevel3Id 为空 → 下拉框1
          this.caloptions.push(item);
        }
      });
    },
    getFirstValidBrandId() {
      // 遍历后端数据，找到第一个有效brandId
      console.log(this.backendData);
      for (const item of this.backendData) {
        // 判空逻辑：排除 null/undefined/空字符串/全空格
        const isValidBrandId = item.brandId && item.brandId.trim() !== "";

        if (isValidBrandId) {
          this.brandId = item.brandId.trim(); // 去除首尾空格
          break; // 找到第一个后立即退出循环，避免多余遍历
        }
      }
      this.dataScope = !this.brandId ? 1 : 2;
      // 可选：如果没有找到任何有效brandId，给出提示
      if (!this.firstValidBrandId) {
        console.warn("后端返回数据中未找到有效brandId");
      }
    },
    async getXhmBrandV2() {
      await getXhmBrandV2({
        taskId: this.taskId
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          this.backendData = res.data.content;
          this.splitDataToDropdowns();
          this.getFirstValidBrandId();
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    async search() {
      this.loading = true;

      await getXhmDetailV2({
        taskId: this.taskId,
        dataCycle: this.daytype,
        brandId: this.brandId,
        cateId: this.cateId,
        dataScope: this.dataScope
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          this.tableData = res.data.contents;
          // this.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      }),
        await this.getXhmOrder();
      await getXhmDailyV2({
        taskId: this.taskId,
        dataCycle: this.daytype,
        brandId: this.brandId,
        cateId: this.cateId,
        dataScope: this.dataScope
      }).then(res => {
        this.loading = false;
        if (res.code == 1000) {
          // 提取X轴数据和Y轴数据
          let data = res.data.result;
          let xData = data.dataDay;
          let yduv = data.contentVisitUv;
          let dzuv = data.contentThumbsCount;
          let followUv = data.contentCollectUv;
          let commentUv = data.contentCommentsCount;
          let searchBrowseUv = data.searchBrowseUv;
          let browseUv = data.searchCount;
          let orderGmv = data.orderGmv;
          let orderUv = data.orderUv;
          let dealGmv = data.orderCompleteGmv;
          let dealUv = data.orderCompleteUv;
          var chartDom = document.getElementById("myChart");
          let myChart = echarts.init(chartDom);
          // 使用ECharts的配置项进行配置
          let option = {
            title: {
              text: this.taskName + "-小红盟每日数据"
            },
            tooltip: {
              trigger: "axis", //坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            legend: {
              data: [
                "阅读UV",
                "点赞UV",
                "收藏UV",
                "评论UV",
                "搜索浏览UV",
                "商品浏览UV",
                "下单GMV",
                "下单UV",
                "成交GMV",
                "成交UV"
              ],
              top: "6%"
            },
            xAxis: {
              type: "category",
              data: xData,
              axisLabel: {
                show: true, //这里的show用于设置是否显示x轴下的字体 默认为true
                interval: 0, //可以设置成 0 强制显示所有标签。如果设置为 1，表示『隔一个标签显示一个标签』，如果值为 2，表示隔两个标签显示一个标签，以此类推。
                textStyle: {
                  //textStyle里面写x轴下的字体的样式
                  color: "#333",
                  fontSize: 13
                },
                rotate: 45
              },
              axisLine: {
                show: true, //这里的show用于设置是否显示x轴那一条线 默认为true
                lineStyle: {
                  //lineStyle里面写x轴那一条线的样式
                  color: "#6FC6F3",
                  width: 2 //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
                }
              }
            },
            yAxis: {
              type: "value",
              //用于设置y轴的字体
              axisLabel: {
                show: true, //这里的show用于设置是否显示y轴下的字体 默认为true
                textStyle: {
                  //textStyle里面写y轴下的字体的样式
                  color: "#333",
                  fontSize: 13
                }
              },
              //用于设置y轴的那一条线
              axisLine: {
                show: true, //这里的show用于设置是否显示y轴那一条线 默认为true
                lineStyle: {
                  //lineStyle里面写y轴那一条线的样式
                  color: "#6FC6F3",
                  width: 2 //轴线的粗细 我写的是2 最小为0，值为0的时候线隐藏
                }
              }
            },
            dataZoom: [
              {
                show: true,
                endValue: 9 //x轴少于10个数据，则显示全部，超过10个数据则显示前10个。
              }
            ],
            series: [
              {
                name: "阅读UV",
                type: "line",
                data: yduv,
                smooth: true
              },
              {
                name: "点赞UV",
                type: "line",
                data: dzuv,
                smooth: true
              },
              {
                name: "收藏UV",
                type: "line",
                data: followUv,
                smooth: true
              },
              {
                name: "评论UV",
                type: "line",
                data: commentUv,
                smooth: true
              },
              {
                name: "搜索浏览UV",
                type: "line",
                data: searchBrowseUv,
                smooth: true
              },
              {
                name: "商品浏览UV",
                type: "line",
                data: browseUv,
                smooth: true
              },
              {
                name: "下单GMV",
                type: "line",
                data: orderGmv,
                smooth: true
              },
              {
                name: "下单UV",
                type: "line",
                data: orderUv,
                smooth: true
              },
              {
                name: "成交GMV",
                type: "line",
                data: dealGmv,
                smooth: true
              },
              {
                name: "成交UV",
                type: "line",
                data: dealUv,
                smooth: true
              }
            ]
          };
          myChart.setOption(option);
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getXhmOrder(); // 重新搜索以更新分页数据
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getXhmOrder(); // 重新搜索以更新分页数据
    },
    handleChange() {
      // 这里执行搜索操作，例如调用API或更新数据
      // 假设有一个search方法来处理搜索逻辑
      this.search();
    },
    handleBrandChange(val) {
      this.dataScope = 1;
      this.brandId = null;
      this.cateId = !val.categoryLevel3Id
        ? val.categoryLevel1Id
        : val.categoryLevel3Id;

      this.search();
    },
    handleCalChange(val) {
      //没有三级类目清空cateid
      this.dataScope = 1;
      this.brandId = null;
      if (!this.hasBrand) {
        this.cateId = null;
        this.brandtype = null;
      } else {
        this.brandId = null;
      }
      (this.dataScope = !this.brandId ? 1 : 2), this.search();
    }
  }
};
</script>

